<template>
  <a v-if="main === to" 
    @click="mainClicked" 
    :class="$route.path === to && activeClass ? activeClass : 'router-link-active'">
    <slot/>
  </a>  
  <router-link v-else
    :to="to"
    :tag="tag"
    :exact="exact"
    :append="append"
    :activeClass="activeClass"
    :event="event"
    :replace="replace">
    <slot />
  </router-link>
</template>

<script>

const toTypes = [String, Object]
const eventTypes = [String, Array]

export default {
  name: 'BvueUiRouterLink',
  props: {
    main: { 
      type:String,
      default: '/'
    },
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  methods: {
    mainClicked() {
      if (this.isDesktop()) {
        this.$router.push(this.to)
      } else if (this.$route.path !== this.to) {
        this.$router.go(-1)
      }
    },
    isDesktop() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return false;
      }
      if (/android/i.test(userAgent)) {
          return false;
      }
      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return false;
      }
      return true;
    }
  },
  computed: {
    replace() {
      if (this.isDesktop()) {
        return false
      } else {
        return this.$route.path !== this.main
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/aside/BvueUiRouterLink.vue